"use client";

import { Button } from "@/components/shadcn/button";
import { Input } from "@/components/shadcn/input";
import { cn } from "@/lib/utils";
import { Eye, EyeOff } from "lucide-react";
import { type ComponentProps, useState } from "react";

export function PasswordInput({
    className,
    ...props
}: ComponentProps<typeof Input>) {
    const [showPassword, setShowPassword] = useState(false);
    const disabled =
        props.value === "" || props.value === undefined || props.disabled;

    return (
        <div className="relative">
            <Input
                type={showPassword ? "text" : "password"}
                className={cn("hide-password-toggle pr-10", className)}
                {...props}
            />
            <Button
                type="button"
                variant="ghost"
                size="sm"
                className="absolute top-0 right-0 h-full px-3 py-2 hover:bg-transparent"
                onClick={() => setShowPassword((prev) => !prev)}
                disabled={disabled}
            >
                {showPassword && !disabled ? (
                    // <EyeIcon className="h-4 w-4" aria-hidden="true" strokeWidth={1} />
                    <Eye size={16} aria-hidden="true" />
                ) : (
                    <EyeOff size={16} aria-hidden="true" />
                    // <EyeOffIcon className="h-4 w-4" aria-hidden="true" strokeWidth={1} />
                )}
                <span className="sr-only">
                    {showPassword ? "Hide password" : "Show password"}
                </span>
            </Button>

            {/* hides browsers password toggles */}
            <style>{`
					.hide-password-toggle::-ms-reveal,
					.hide-password-toggle::-ms-clear {
						visibility: hidden;
						pointer-events: none;
						display: none;
					}
				`}</style>
        </div>
    );
}
